import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import Typography from "@material-ui/core/Typography";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import { observer, PropTypes as mbxPropTypes } from "mobx-react";

const AgentRow = observer(({ agentList, isMobile }) => {
  return (
    <TableBody>
      {agentList.map(({ Agent, LastActive }, i) => {
        const activeDate = new Date(LastActive);
        return (
          <TableRow
            key={`agent-list-${Agent}-${i}`}
            style={{ backgroundColor: i % 2 ? "#fff" : "#eee" }}
          >
            <TableCell>
              <Typography
                variant={!isMobile ? "subheading" : "display1"}
                align="left"
              >
                {Agent}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant={!isMobile ? "subheading" : "display1"}
                align="left"
              >
                {moment(activeDate).isValid()
                  ? moment(activeDate).format("MMMM DD, YYYY")
                  : "Never"}
              </Typography>
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
});

AgentRow.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  agentList: mbxPropTypes.observableArrayOf(PropTypes.object),
};

export default AgentRow;
